/**
 * Custom JavaScript - Tema Shopify
 * Extensões e customizações do tema Tondin Ecommerce
 *
 * EVENTOS DISPONÍVEIS DO TEMA:
 * - variant:changed: Quando variante muda
 * - variant:added: Quando variante é adicionada ao carrinho
 * - cart:updated: Quando carrinho é atualizado
 * - cart:refresh: Para forçar refresh do carrinho
 */

(function() {
  'use strict';

  // ==========================================================================
  // CONFIGURAÇÃO
  // ==========================================================================

  const CONFIG = {
    DEBUG: false,
    VARIANT_TRANSITION_DELAY: 150,
    VARIANT_REVEAL_DURATION: 400
  };

  function log(...args) {
    if (CONFIG.DEBUG) console.log('[Custom]', ...args);
  }

  // ==========================================================================
  // CALCULADORA DE FRETE
  // ==========================================================================

  window.exibir = function() {
    const cepInput = document.getElementById('campo-cep');
    if (!cepInput) return;

    const cepValue = cepInput.value.replace(/\D/g, '');

    if (cepValue.length >= 8) {
      const resultado = document.querySelector('.frete-resultado');
      if (resultado) {
        resultado.style.display = 'none';
        setTimeout(() => {
          resultado.style.display = '';
        }, 500);
      }
    } else {
      alert('Insira um CEP válido');
    }
  };

  // ==========================================================================
  // OWL CAROUSEL (se existir)
  // ==========================================================================

  function initOwlCarousel() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.owlCarousel === 'undefined') {
      return;
    }

    const $ = jQuery;

    $('.owl-carousel').each(function() {
      if ($(this).data('owl.carousel')) return; // Já inicializado

      $(this).owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        responsive: {
          0: { items: 2 },
          600: { items: 3 },
          1000: { items: 5 }
        }
      });
    });
  }

  // ==========================================================================
  // BOTÃO FLUTUANTE ADD TO CART
  // ==========================================================================

  function initFloatingButton() {
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.flutuante')) return;

      const addToCartBtn = document.querySelector(
        '.product-form__payment-container button[type="submit"], ' +
        'button[data-product-add-to-cart-button]'
      );

      if (addToCartBtn) {
        addToCartBtn.click();
      }
    });
  }

  // ==========================================================================
  // VARIANT CHANGE - Transição Suave de Galeria
  // ==========================================================================

  const VariantTransition = {
    isTransitioning: false,
    revealTimeout: null,

    hide() {
      const productMedia = document.querySelector('product-media');
      if (!productMedia || this.isTransitioning) return;

      this.isTransitioning = true;

      // Cancelar reveal pendente
      if (this.revealTimeout) {
        clearTimeout(this.revealTimeout);
        this.revealTimeout = null;
      }

      // Salvar altura para evitar layout shift
      const wrapper = productMedia.querySelector('.product__media-list-wrapper');
      const mediaList = productMedia.querySelector('.product__media-list');

      if (wrapper && mediaList) {
        const height = mediaList.offsetHeight;
        if (height > 0) {
          wrapper.style.minHeight = height + 'px';
        }
      }

      // Aplicar classes de transição
      productMedia.classList.remove('is-revealing');
      productMedia.classList.add('is-transitioning');

      log('Gallery hidden');
    },

    reveal() {
      const productMedia = document.querySelector('product-media');
      if (!productMedia) return;

      // Cancelar reveal pendente
      if (this.revealTimeout) {
        clearTimeout(this.revealTimeout);
      }

      this.revealTimeout = setTimeout(() => {
        productMedia.classList.remove('is-transitioning');
        productMedia.classList.add('is-revealing');

        // Limpar após animação
        setTimeout(() => {
          productMedia.classList.remove('is-revealing');

          const wrapper = productMedia.querySelector('.product__media-list-wrapper');
          if (wrapper) {
            wrapper.style.minHeight = '';
          }

          this.isTransitioning = false;
          this.revealTimeout = null;

          log('Gallery revealed');
        }, CONFIG.VARIANT_REVEAL_DURATION);
      }, CONFIG.VARIANT_TRANSITION_DELAY);
    },

    init() {
      // Seletores de variante do tema
      const VARIANT_SELECTORS = [
        '.variant-swatch__item',
        '.variant-swatch__radio',
        '.block-swatch__item',
        '.block-swatch__radio',
        '.combo-box__option-item',
        'label[for*="option"]'
      ].join(', ');

      // Interceptar cliques (capture phase)
      document.addEventListener('click', (e) => {
        const selector = e.target.closest(VARIANT_SELECTORS);
        if (!selector) return;

        const productForm = selector.closest('.product-form__variants, product-variants');
        if (!productForm) return;

        // Verificar se vai mudar variante
        const input = selector.querySelector('input[type="radio"]') ||
                      document.getElementById(selector.getAttribute('for'));

        if ((input && !input.checked) || !input) {
          this.hide();
        }
      }, true);

      // Interceptar change em inputs
      document.addEventListener('change', (e) => {
        const target = e.target;
        if (target.matches('.variant-swatch__radio, .block-swatch__radio, select[name*="option"], input[name*="option"]')) {
          this.hide();
        }
      }, true);

      // Revelar quando variante mudar
      document.addEventListener('variant:changed', (e) => {
        if (e.detail && e.detail.variant) {
          this.reveal();
        }
      });

      log('Variant transition initialized');
    }
  };

  // ==========================================================================
  // INICIALIZAÇÃO
  // ==========================================================================

  function init() {
    initFloatingButton();
    VariantTransition.init();

    // Aguardar jQuery para Owl Carousel
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOwlCarousel);
    } else {
      initOwlCarousel();
    }

    log('Custom.js initialized');
  }

  // Iniciar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinicializar em seções Shopify
  document.addEventListener('shopify:section:load', () => {
    initOwlCarousel();
    VariantTransition.init();
  });

})();
